import { track } from "@/features/analytics";
import { useDeleteAccountMutation } from "@api/accounts";
import Button from "@components/ui/button";
import DialogBase from "@components/ui/dialog-base";
import Spinner from "@components/ui/spinner";
import { cn } from "@lib/cn";
import { useAppDispatch } from "@store";
import { closeDialog } from "@store/dialogs";
import { toast } from "react-toastify";

const DIALOG_ID = "user-menu-delete-account-dialog";

export const UserMenuDeleteAccountDialog = () => {
  const dispatch = useAppDispatch();

  const [delteAccount, { isLoading }] = useDeleteAccountMutation();

  const handleClose = () => {
    dispatch(closeDialog(DIALOG_ID));
  };

  const handleSubmit = async () => {
    if (isLoading) return;

    try {
      await delteAccount().unwrap();
      window.location.reload();
    } catch (e) {
      track("error deleting account", {
        error: e,
      });
      toast.error("Error deleting account");
    }
  };

  return (
    <DialogBase>
      <DialogBase.Header title="Delete account" onClose={handleClose} />
      <DialogBase.Content>
        <p className="tw-text-[13px]">
          Are you sure you want to delete this organization data?
        </p>
      </DialogBase.Content>
      <DialogBase.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Go back
        </Button>
        <Button
          variant="destructive"
          onClick={handleSubmit}
          className={cn("tw-ml-4", isLoading && "tw-cursor-not-allowed")}
        >
          {isLoading ? (
            <>
              <Spinner className="tw-mr-2 tw-size-3 tw-border-white" />
              Deleting...
            </>
          ) : (
            "Yes, delete"
          )}
        </Button>
      </DialogBase.Footer>
    </DialogBase>
  );
};

UserMenuDeleteAccountDialog.dialogId = DIALOG_ID;
